import { vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "cart-item py-3 px-2 border-b border-t" }
const _hoisted_2 = { class: "flex justify-between align-center" }
const _hoisted_3 = { class: "check flex-none mr-6" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = { class: "format text-xs" }
const _hoisted_6 = { class: "quantity-number font-bold tabular-nums" }
const _hoisted_7 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "flex-none mr-6 h-5 w-5" }, null, -1)
const _hoisted_9 = { class: "nome-cliente flex-1 text-left" }
const _hoisted_10 = { class: "qta-cliente flex-none" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("li", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, [
        _withDirectives(_createElementVNode("input", {
          name: "check-item",
          type: "checkbox",
          class: "h-5 w-5 text-orange-600 border-orange-300 rounded",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.checked) = $event)),
          onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleChecked && _ctx.toggleChecked(...args)))
        }, null, 544), [
          [_vModelCheckbox, _ctx.checked]
        ])
      ]),
      _createElementVNode("p", {
        class: _normalizeClass(["product-name text-base leading-tight flex-1 text-left font-bold", _ctx.classChecked]),
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('toggle')))
      }, [
        _createTextVNode(_toDisplayString(_ctx.prodotto.nome), 1),
        _hoisted_4,
        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.prodotto.formato), 1)
      ], 2),
      _createElementVNode("p", {
        class: _normalizeClass(["quantity flex-none text-base", _ctx.classChecked])
      }, [
        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.prodotto.qta), 1)
      ], 2)
    ]),
    (!_ctx.chiuso)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.prodotto.clienti, (cliente, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: index,
              class: _normalizeClass(["flex justify-between align-center text-sm py-1", _ctx.classChecked])
            }, [
              _hoisted_8,
              _createElementVNode("span", _hoisted_9, _toDisplayString(cliente.nome), 1),
              _createElementVNode("span", _hoisted_10, _toDisplayString(cliente.qta), 1)
            ], 2))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}